/** DTO for the response of generating an embed URL for QuickSight. The embed URL string is used to load an iframe. */
export interface GetEmbedUrlResponse {
    embed_url: string;
}

export enum AnalyticsEtlStatus {
    NEVER_STARTED = 'Never started',
    IN_PROGRESS = 'In progress',
    FAILED = 'Failed',
    SUCCEEDED = 'Succeeded',
}

/** Metadata about runs of the ETL process that refreshes a Client's Analytics datasets. */
export interface AnalyticsEtlMetadata {
    status: AnalyticsEtlStatus;

    /** Present unless `status` is `NEVER_STARTED`. */
    last_started_timestamp?: string;
    /** Present if the ETL process has succeeded in the past. */
    last_succeeded_timestamp?: string;
}
